import { supabase } from "../lib/supabase";

export async function listPortfolioProperties() {
  const { data, error } = await supabase
    .from("portfolio_properties")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createPortfolioProperty(payload) {
  const { data, error } = await supabase
    .from("portfolio_properties")
    .insert(payload)
    .select("*")
    .single();

  if (error) throw error;
  return data;
}

export async function deletePortfolioProperty(id) {
  const { error } = await supabase
    .from("portfolio_properties")
    .delete()
    .eq("id", id);

  if (error) throw error;
}
